var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form",
            { attrs: { slot: "detail", form: _vm.form }, slot: "detail" },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "签名授权",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                          },
                        },
                        [
                          _c(
                            "j-dict-select-tag",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: ["authFlag"],
                                  expression: "['authFlag']",
                                },
                              ],
                              attrs: {
                                type: "list",
                                "trigger-change": true,
                                dictCode: "signature_status",
                                placeholder: "请选择签名授权",
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.authFlag_dictText))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "签名时间",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                          },
                        },
                        [
                          _c("j-date", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["authTime"],
                                expression: "['authTime']",
                              },
                            ],
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: "请选择签名时间",
                              "trigger-change": true,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "在校瞬间授权",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                          },
                        },
                        [
                          _c(
                            "j-dict-select-tag",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: ["empower"],
                                  expression: "['empower']",
                                },
                              ],
                              attrs: {
                                type: "list",
                                "trigger-change": true,
                                dictCode: "signature_status",
                                placeholder: "请选择在校瞬间授权",
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.empower_dictText))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "消息推送授权",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                          },
                        },
                        [
                          _c(
                            "j-dict-select-tag",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: ["receive"],
                                  expression: "['receive']",
                                },
                              ],
                              attrs: {
                                type: "list",
                                "trigger-change": true,
                                dictCode: "signature_status",
                                placeholder: "请选择消息推送授权",
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.receive_dictText))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "付费状态",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                          },
                        },
                        [
                          _c(
                            "j-dict-select-tag",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: ["feeStatus"],
                                  expression: "['feeStatus']",
                                },
                              ],
                              attrs: {
                                type: "list",
                                "trigger-change": true,
                                dictCode: "fee_status",
                                placeholder: "请选择付费状态",
                              },
                              on: { change: _vm.changeFeeState },
                            },
                            [_vm._v(" " + _vm._s(_vm.feeStatus_dictText))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "试用期限",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                          },
                        },
                        [
                          _c("j-date", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: "请选择试用期限",
                              "trigger-change": true,
                            },
                            model: {
                              value: _vm.model.limitTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.model, "limitTime", $$v)
                              },
                              expression: "model.limitTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }